

(function($){

    $(document.body).trigger('wc_fragments_refreshed');
  
    var videoSrc = $('#videoSrc');

    if ($(window).width() < 768) {
        videoSrc.attr('src', 'https://player.vimeo.com/video/1095056223?h=b723651f03&badge=0&portrait=0&muted=1&autopause=0&loop=1&background=1');
    } else {
        videoSrc.attr('src', 'https://player.vimeo.com/video/1094984732?h=4b8de0a1df&badge=0&portrait=0&muted=1&autopause=0&loop=1&background=1');
    }

    $(window).on('resize', function(){
        if ($(window).width() < 768) {
        videoSrc.attr('src', 'https://player.vimeo.com/video/1095056223?h=b723651f03&badge=0&portrait=0&muted=1&autopause=0&loop=1&background=1');
        } else {
        videoSrc.attr('src', 'https://player.vimeo.com/video/1094984732?h=4b8de0a1df&badge=0&portrait=0&muted=1&autopause=0&loop=1&background=1');
        }
    });
     

   // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){

            $(this).removeClass('open');
            $('body').removeClass('disable');
            $('#mainMenu').removeClass('nav-open');

        } else {

            $('body').addClass('disable');
            $(this).addClass('open');
           
            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#mainMenu').addClass('nav-open');

        }

    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	        $('#trigger').removeClass('open');
	        $('body').removeClass('disable');
	        $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#mainMenu').removeClass('nav-open');
	    }

    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


   


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});

     //Parallax Animation
    var image = document.getElementsByClassName('obs-img');
          new trustPara(image, {
          maxTransition: 300
    });

    // Initiate aos animations
	//AOS.init();

    // Initiate Rellax Scrolling
    window.onload = function(){
        var rellax = new Rellax('.rellax', {
        speed: -2,
        center: true,
        round: false,
        vertical: true,
        horizontal: true
    });

    $(window).scroll(function() {
       // rellax.refresh();
    })
}
})(jQuery);